export default __webpack_public_path__ + "static/media/premium_03.d25669f4.jpg";